import {
  JobAdjustmentStatusEnum,
  JobCancellationStatusEnum,
  JobCardShippingItem,
  JobItem,
  JobParticipantEnum,
  JobTypeEnum,
} from 'domains/workspaceDomain';
import { SHIPPING_DATE_FORMAT } from 'components/RevxDate';
import dayjs from 'dayjs';

const { PROXY, CUSTOMER, OPERATOR, PRODUCER } = JobParticipantEnum;

const useJobCardInfo = (data: JobItem) => {
  const {
    jobContacts,
    billingRequestor,
    jobType,
    adjustmentStatus,
    cancellationStatus,
  } = data;
  const shippingItems = data?.jobCardShippingItems && [
    ...data?.jobCardShippingItems,
  ];
  const hasCustomer = data?.participants?.includes(CUSTOMER);
  const hasProxy = data?.participants?.includes(PROXY);
  const hasOperator = data?.participants?.includes(OPERATOR);
  const hasProducer = data?.participants?.includes(PRODUCER);
  const isInternalJob = jobType === JobTypeEnum.INTERNAL;
  const adjustmentJobAccepted =
    adjustmentStatus === JobAdjustmentStatusEnum.ACCEPTED;
  const hasCancelStatus = cancellationStatus !== JobCancellationStatusEnum.NONE;
  const onlyOneParticipant = data?.participants?.length === 1;

  const sortByShipTime = (a: JobCardShippingItem, b: JobCardShippingItem) =>
    dayjs(a.actualShipTime || a.estimatedShipTime).valueOf() -
    dayjs(b.actualShipTime || b.estimatedShipTime).valueOf();
  const sortByDeliveryTime = (a: JobCardShippingItem, b: JobCardShippingItem) =>
    dayjs(b.estimatedDeliveryTime).valueOf() -
    dayjs(a.estimatedDeliveryTime).valueOf();
  const shipDate = shippingItems?.sort(sortByShipTime)?.[0];
  const deliveryDate = shippingItems?.sort(sortByDeliveryTime)?.[0];
  const billingContact = [
    billingRequestor?.firstName,
    billingRequestor?.lastName,
  ]
    .filter(Boolean)
    .join(' ');
  return {
    shipDate: dayjs(
      shipDate?.actualShipTime || shipDate?.estimatedShipTime
    ).format(SHIPPING_DATE_FORMAT),
    deliveryDate: dayjs(deliveryDate?.estimatedDeliveryTime).format(
      SHIPPING_DATE_FORMAT
    ),
    buyerName: jobContacts?.createBy?.fullName,
    buyerCompany: jobContacts?.createBy?.company,
    supplierOrgName: jobContacts?.supplierOrg?.orgName,
    billingContact,
    billingCompany: billingRequestor?.company,
    hasCustomer,
    hasProxy,
    hasOperator,
    hasProducer,
    isInternalJob,
    adjustmentJobAccepted,
    hasCancelStatus,
    onlyOneParticipant,
  };
};

export default useJobCardInfo;
